export default function getSanitizedNumber(val: string): number {
  return Number(val.replace(/[^\d.]/g, ''));
}
